import React from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
const Events = () => {
    var settings = {
        loop: true,
        margin: 10,
        responsiveClass: true,
        autoplay: true,
        dots: true,
        items: 3,
        responsive: {
            0: {
                items: 1,
            },
            567: {
                items: 2,
            },
            768: {
                items: 2,
            },
            992: {
                items: 3,
            },
            1200: {
                items: 2,
            }, 
            1350: {
                items: 3,
            },
            1600: {
                items: 3,
            }
        }
    };

    return (
        <OwlCarousel className='owl-theme' loop margin={10} {...settings}>
            <div className="item">
                <div className='evt-blk'>
                    <div className="evt-img">
                        <img src="/Images/holi.png" />
                        <div className="date">Mar <span>25</span></div>
                        <div className="evt-title"><h3>Holi</h3></div>
                    </div>
                    <div className='evt-content'>
                        <p>Wishing you a very happy holi filled with bright colors, water balloons, delicious gujiyas...</p>
                        <p><img src="/Images/location.png" />School Campus <span><img src="/Images/clock.png"></img> 8:00 AM</span></p>
                    </div>
                </div>
            </div>
            <div className="item">
                <div className='evt-blk'>
                    <div className="evt-img">
                        <img src="/Images/good-friday.png" />
                        <div className="date">Mar <span>29</span></div>
                        <div className="evt-title"><h3>Good Friday</h3></div>
                    </div>
                    <div className='evt-content'>
                        <p>May on this GOOD FRIDAY we start it with Fasting & Prayers so that we can bring...</p>
                        <p><img src="/Images/location.png" />School Campus <span><img src="/Images/clock.png"></img> 8:00 AM</span></p>
                    </div>
                </div>
            </div>
            <div className="item">
                
            <div className='evt-blk'>
                    <div className="evt-img">
                        <img src="/Images/easter.png" />
                        <div className="date">Mar <span>31</span></div>
                        <div className="evt-title"><h3>Easter</h3></div>
                    </div>
                    <div className='evt-content'>
                        <p>The Easter Egg symbolizes our ability to break out of the hardened, protect...</p>
                        <p><img src="/Images/location.png" />School Campus <span><img src="/Images/clock.png"></img> 8:00 AM</span></p>
                    </div>
                </div>
            </div> 
        </OwlCarousel>
    );
};

export default Events;
